import { useEffect } from 'react';
import { useSelector } from 'Hooks';
import { datadogLogs } from '@datadog/browser-logs';

const CartManager = () => {
  const cartId = useSelector((state) => state.cartId);
  
  useEffect(() => {
    datadogLogs.addLoggerGlobalContext('cart', cartId);
  }, [cartId]);

  return null;
};

export default CartManager;
